import { NestedTreeControl } from '@angular/cdk/tree';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Helpers } from 'src/app/@shared/models/helper-sistema.model';
import { ManutencaoHelperService } from 'src/app/services/manutencao-helper/manutencao-helper.service';

@Component({
  selector: 'app-arvore-helpers',
  templateUrl: './arvore-helpers.component.html',
  styleUrls: ['./arvore-helpers.component.scss']
})
export class ArvoreHelpersComponent
  implements OnInit {
  public activeMessage: any; // Use the appropriate type here
  bold: any = [];
  @ViewChild('tree') tree;
  treeControl = new NestedTreeControl<Helpers>(node => node.children);
  dataSource = new MatTreeNestedDataSource<Helpers>();
  todos_helpers: Helpers[] = [];
  todos_helpers_copy: Helpers[] = [];
  // helperInfo: Helpers;

  @Input('isLoading') isLoading = true;
  @Input('modoEdicao') modoEdicao = false;

  @Output() changeLoading = new EventEmitter();
  @Output() helperInfo = new EventEmitter();

  constructor(
    private service: ManutencaoHelperService,
    public snackBar: MatSnackBar
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isLoading && (changes['modoEdicao']?.currentValue !== changes['modoEdicao']?.previousValue)) {
      this.atualizaDataSource();
    }
  }

  ngOnInit() {
    this.getAllHelpers();
  }

  loadingEvent() {
    this.changeLoading.emit(this.isLoading);
  }

  editHelper(node) {
    this.helperInfo.emit(node);
    this.activeMessage = node;
  }

  public getAllHelpers() {
    this.service.getAllHelpers().subscribe((response: Helpers[]) => {
      this.todos_helpers = response;
      this.todos_helpers_copy = JSON.parse(JSON.stringify(this.todos_helpers));
      this.atualizaDataSource();
      this.isLoading = false;
      this.loadingEvent();
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar a árvore! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }


  obterFiltrado(array_helpers: Helpers[]) {
    let _copy = JSON.parse(JSON.stringify(array_helpers));
    return _copy.filter(o => {
      let _keep = true;
      if (o.children?.length > 0) {
        o.children = this.obterFiltrado(o.children);
        _keep = o.children.length > 0;
      }
      return _keep;
    })
  }

  atualizaExterno() {
    this.isLoading = true;
    setTimeout(() => {
      this.atualizaDataSource();
      this.isLoading = false;
    }, 500);
  }

  atualizaDataSource() {
    this.dataSource.data = !this.modoEdicao ? this.todos_helpers : this.obterFiltrado(this.todos_helpers_copy);
    let selectParents = node => {
      if (!node) return;
      else if (node.children.every(ch => ch.selected))
        node.selected = true;
      else if (node.children.some(ch => ch.selected || ch.indeterminate))
        node.indeterminate = true;
      selectParents(node.parent);
    };

    let selectChildren = (node) => {
      node.selected = !!node.perfilAcessoId;
      if (node.children && node.children.length)
        node.children.forEach(v => {
          v.parent = node;
          selectChildren(v);
        });
      else selectParents(node.parent);
    };

    this.dataSource.data.forEach(selectChildren);


    Object.keys(this.dataSource.data).forEach(x => {
      this.setParent(this.dataSource.data[x], null);
    });
    this.treeControl.dataNodes = this.dataSource.data;
    this.treeControl.expandAll();
  }

  hasChild = (_: number, node: Helpers) =>
    !!node.children && node.children.length > 0

  setParent(data, parent) {
    data.parent = parent;
    if (data.children) {
      data.children.forEach(x => {
        this.setParent(x, data);
      });
    }
  }

  expandAll() {
    this.treeControl.expandAll();
  }

  collapseAll() {
    this.treeControl.collapseAll();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
